<template>
  <v-app>
    <v-app-bar app color="#272d44" dark fixed>
      <v-toolbar-title v-text="title" />
      <notice-unread-component></notice-unread-component>
    </v-app-bar>

    <v-main>
      <router-view></router-view>
    </v-main>
  </v-app>
</template>

<script>
import NoticeUnreadComponent from "@/framework/components/NoticeUnread.vue";

export default {
  name: "App",
  components: {
    // Header
    NoticeUnreadComponent,
  },
  data() {
    return {
      title: "",
      drawerToggle: false,
    };
  },
};
</script>

<style>
.v-toolbar__title {
  width: 100%;
  text-align: center;
}
</style>
